import { render, staticRenderFns } from "./couponItem.vue?vue&type=template&id=0c7b79da&scoped=true&"
import script from "./couponItem.vue?vue&type=script&lang=ts&"
export * from "./couponItem.vue?vue&type=script&lang=ts&"
import style0 from "./couponItem.vue?vue&type=style&index=0&id=0c7b79da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7b79da",
  null
  
)

export default component.exports